<template>
<a-trigger trigger="click" position="br" :unmount-on-close="false" :popup-translate="[0, 8]">
        <div class="file-avatar-img" id="avatar-img">
            <div v-if="userAvatar === ''" class="user-avatar" :style="avatarColorStye()">
                <div class="user-name">{{ userName() }}</div>
            </div>
            <img v-else :src="userAvatar" style="object-fit: cover"/>
        </div>
        <template #content>
            <div class="user-info-card">
                <div class="info-header">
                    <div v-if="userAvatar === ''" class="user-avatar" :style="avatarColorStye()">
                        <div class="user-name">{{ userName() }}</div>
                    </div>
                    <img v-else :src="userAvatar" style="object-fit: cover"/>
                    <div class="user-info">
                        <div class="user-name">
                            {{ this.currentUserInfo?.memberName }}
                        </div>
                        <div class="user-department">{{ userDepartment }}</div>
                    </div>
                </div>
                <a-trigger trigger="hover" position="lt" :popup-translate="[-24, 8]">
                    <div class="user-info-card-i18n-setting">
                        <svg-icon name="header-lang_icon" class="user-info-card-i18n-icon"></svg-icon>
                        <span>{{$t("语言")}}</span>
                        <svg-icon name="header-lang_right_arrow" class="user-info-card-i18n-right-arrow"></svg-icon>
                    </div>
                    <template #content>
                        <div class="user-info-card-i18n-list">
                            <div class="i18n-list">
                                <div class="i18n-detail" :class="{ current: currentLang == item.id }" v-for="(item, index) in i18nList" :key="item.id" @click.stop="handleChangeLang(item)">
                                    <span>
                                        {{ item.name }}
                                    </span>
                                    <svg-icon v-if="currentLang == item.id" name="header-lang_current" class="i18n-detail-current-icon"></svg-icon>
                                </div>
                            </div>
                        </div>
                    </template>
                </a-trigger>
                <div class="logout-btn" @click="handlerLogout">
                    <img src="@/assets/img/setting/icon_setting_logout.svg"/>{{$t("退出登录")}}                </div>
            </div>
        </template>
    </a-trigger>
</template>

<script lang="ts">
import nameColor from '../../utils/nameColor';

import { clearCookieAndToLogin } from '../../login';
import { mapState } from 'vuex';
import { useI18n, intl } from 'tci18n-vue3';
const { lang } = useI18n();
import { switchLang } from '../../utils/lang';
import { logoutUtil } from '@/utils/logoutUtil';

export default {
  name: 'EditHeadLogoutPopup',
  // props: { },
  data() {
    return {
      currentLang: ('' as string),
      i18nList: [
      {
        name: intl.$t("简体中文"),
        id: 'zh-cn' },

      {
        name: intl.$t("英语"),
        id: 'en-us' }] };



  },
  created() {
    this.initLang();
  },
  computed: {
    ...mapState({
      currentUserInfo: (state: any) => state.userModule.userDetail,
      showtype: (state: any) => state.kbModule.showtype,
      wikiI18n: (state: any) => state.kbModule.wikiI18n }),

    userAvatar() {
      const str = this.currentUserInfo?.memberAvatar;
      if (str == null || str === undefined) return '';
      return JSON.parse((str as string))['100'];
    },
    userDepartment() {
      return (
        this.currentUserInfo.departments?.
        map((e) => {
          return e.departmentName;
        }).
        join('/') ?? '--');

    } },

  methods: {
    avatarColorStye() {
      const memberName: string = this.currentUserInfo?.memberName;
      if (!memberName) {
        return 'display: none;';
      }
      let avatarColor = nameColor.getNameColor(memberName);
      return `background-color: ${avatarColor}`;
    },
    userName() {
      const memberName: string = this.currentUserInfo?.memberName;
      return nameColor.getLastName(memberName);
    },
    handlerLogout() {
      logoutUtil((isLogout: boolean) => {
        clearCookieAndToLogin(isLogout);
      });
    },
    initLang() {
      this.currentLang = lang;
      if (this.currentLang !== 'zh-cn') {
        this.i18nList.reverse();
      }
    },
    handleChangeLang(language: any) {
      if (language.id !== this.currentLang) {
        this.currentLang = language.id;
        switchLang(language.id);
      }
    } } };
</script>

<style lang="scss">
.logout_dialog {
    width: 533px !important;
    // height: 160px !important;
    padding: 0px 0px 16px 0 !important;

    .arco-modal-header {
        height: 48px !important;
        border: none !important;
        padding: 24px 24px 0px 24px !important;
        line-height: 48px !important;
        text-align: end;
        margin-bottom: 8px !important;
        .arco-modal-title {
            height: 24px !important;
            font-size: 16px !important;
            font-weight: 600;
            color: #121317;
        }
    }

    .arco-modal-body {
        padding: 0px 0px !important;
    }

    .logout_dialog_body {
        font-size: 14px;
        color: #222329 !important;
        text-align: start !important;
        font-weight: 400 !important;
        margin: 0px 52px !important;
    }

    .arco-modal-footer {
        border: none !important;
        height: 36px !important;
        margin-top: 24px;
        padding: 0px 16px 0px 0px !important;
        display: flex !important;
        justify-content: flex-end;

        .arco-btn {
            margin-right: 8px;
            border-radius: 8px;
            width: 76px;
            height: 36px;
        }

        .arco-btn-primary {
            background-color: #ff5f5f !important;
            color: #fff !important;
            font-size: 14px !important;
            font-weight: 500 !important;
        }
        .arco-btn-secondary {
            background-color: #ffffff !important;
            color: #222329 !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            border: 1px solid #cfd3d6 !important;
        }
    }
}

.logout_dialog_mobile {
    width: calc(100% - 64px) !important;
    margin: 0px 32px !important;
    // height: 160px !important;
    padding: 0px 0px 16px 0 !important;
    border-radius: 16px !important;

    .arco-modal-header {
        height: 48px !important;
        border: none !important;
        padding: 24px 24px 0px 24px !important;
        line-height: 48px !important;
        text-align: end;
        margin-bottom: 8px !important;
        .arco-modal-title {
            margin-bottom: 16px !important;
            height: 24px !important;
            font-size: 16px !important;
            font-weight: 600;
            color: #121317;
            justify-content: center !important;

            .arco-modal-title-icon {
                display: none !important;
            }
        }
    }

    .arco-modal-body {
        padding: 0px 0px !important;
    }

    .logout_dialog_body_mobile {
        font-size: 14px;
        color: #222329 !important;
        text-align: center !important;
        font-weight: 400 !important;
        margin: 0px 52px !important;
    }

    .arco-modal-footer {
        border: none !important;
        height: 36px !important;
        margin-top: 24px;
        padding: 0px 32px !important;
        display: flex !important;
        justify-content: space-between;

        .arco-btn {
            margin-right: 8px;
            border-radius: 8px;
            width: 76px;
            height: 36px;
        }

        .arco-btn-primary {
            width: 126px;
            height: 44px;
            background-color: #ff5f5f !important;
            color: #fff !important;
            font-size: 14px !important;
            font-weight: 500 !important;
        }
        .arco-btn-secondary {
            width: 126px;
            height: 44px;
            background-color: #ffffff !important;
            color: #222329 !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            border: 1px solid #cfd3d6 !important;
        }
    }
}
</style>

<style lang="scss" scoped>
.file-avatar-img {
    width: 26px;
    height: 26px;
    border-radius: 4px;

    img {
        width: 26px;
        height: 26px;
        border-radius: 4px;
    }

    .user-avatar {
        width: 26px;
        height: 26px;
        border-radius: 6px;
    }
}

.user-info-card {
    width: 280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border: 1px solid #e6e8ec;
    box-shadow: 0 8px 12px 0 #1213171a;
    border-radius: 8px;

    .info-header {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        width: 248px;
        margin-top: 16px;

        .user-avatar {
            width: 48px;
            height: 48px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;

            .user-name {
                font-family: PingFangSC-Medium;
                font-weight: 500;
                font-size: 9px;
                color: #ffffff;
                line-height: 26px;
                letter-spacing: 0;
            }
        }

        img {
            width: 48px;
            height: 48px;
            border-radius: 8px;
            flex-shrink: 0;
        }

        .user-info {
            margin-left: 14px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;

            .user-name {
                margin-bottom: 7px;
                font-weight: 600;
                font-size: 17px;
                color: #121317;
                line-height: 24px;
            }

            .user-department {
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 12px;
                color: #646573;
                line-height: 17px;
            }
        }
    }

    .logout-btn {
        margin: 4px 16px 12px 16px;
        width: 248px;
        height: 40px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #222329;
        line-height: 20px;
        cursor: pointer;

        &:hover {
            background: #f4f6f9;
        }

        img {
            margin: 0 8px;
            width: 20px;
            height: 20px;
        }
    }

    .user-info-card-i18n-setting {
        margin: 16px 16px 0 16px;
        width: 248px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        border-radius: 8px;
        cursor: pointer;

        span {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #222329;
            line-height: 20px;
            display: flex;
            flex: 1;
        }

        &:hover {
            background: #f4f6f9;
        }

        .user-info-card-i18n-icon {
            width: 20px;
            height: 20px;
            margin: 0 8px;
        }

        .user-info-card-i18n-right-arrow {
            width: 14px;
            height: 14px;
            margin-right: 8px;
        }
    }
}

.user-info-card-i18n-list {
    width: 180px;
    height: 88px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border: 1px solid #e6e8ec;
    box-sizing: border-box;
    box-shadow: 0 8px 12px 0 #1213171a;
    border-radius: 8px;

    .i18n-list {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .i18n-detail {
            height: 40px;
            width: 172px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            cursor: pointer;
            border-radius: 8px;

            span {
                margin-left: 8px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 14px;
                color: #222329;
                letter-spacing: 0;
                flex: 1;
            }

            &:hover {
                background: #f4f6f9;
            }

            &.current {
                color: #5c70ff;
            }

            .i18n-detail-current-icon {
                width: 12px;
                height: 12px;
                margin-right: 8px;
            }
        }
    }
}
</style>
